import { render, staticRenderFns } from "./ProblemTimeEdit.vue?vue&type=template&id=107656c8&scoped=true"
import script from "./ProblemTimeEdit.vue?vue&type=script&lang=js"
export * from "./ProblemTimeEdit.vue?vue&type=script&lang=js"
import style0 from "./ProblemTimeEdit.vue?vue&type=style&index=0&id=107656c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107656c8",
  null
  
)

export default component.exports